module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kaigyo-72a47860e11168068609976544cce1ac.png";